import { onMounted, ref } from 'vue';
import { InputUtil } from '@/assets/ts/_utils/InputUtil';

export function CustomInput(props, { emit }) {
  const customInput = ref<HTMLElement | null>(null);
  const inputValue = ref<string>('');

  onMounted(() => {
    if (props.value) {
      inputValue.value = props.value;
    }
  });

  return {
    customInput,
    inputValue,
    inputStyles: InputUtil.inputStyles(props.inputStyles),
  };
}
